import { LandingCheckout, LandingCheckoutStatusEnum, LandingPage, SimpleLandingCheckout } from '@dev/ee-api/ee-api-models';
import { ActionCreator } from 'redux';
import { GetCheckoutsParams } from '@/services/ElasticApi';
import {
    CheckoutsActionTypes,
    ClearPreviewTemplateAction,
    DeleteCheckoutAction,
    DeleteCheckoutSuccessAction,
    DeleteCheckoutErrorAction,
    GetAllCheckoutsErrorAction,
    GetAllCheckoutsStartAction,
    GetAllCheckoutsSuccessAction,
    GetCheckoutByNameErrorAction,
    GetCheckoutByNameStartAction,
    GetCheckoutByNameSuccessAction,
    LoadPreviewTemplateAction,
    LoadPreviewTemplateErrorAction,
    LoadPreviewTemplateSuccessAction,
    PickCheckoutsAction,
    CheckoutListState,
    UnpickAllCheckoutsAction,
    UpdateCheckoutStatusSuccessAction,
    UpdateCheckoutStatusErrorAction,
    UpdateCheckoutStatusStartAction,
    StdLoadListInterface,
} from './types';
import { ApplicationState } from '..';


export const GetAllCheckoutsStart: ActionCreator<GetAllCheckoutsStartAction> = (
    params: StdLoadListInterface
): GetAllCheckoutsStartAction => ({
    type: CheckoutsActionTypes.GET_ALL_CHECKOUTS_START,
    payload: {
        loadingTemplates: true,
        page: params.page,
        limit: params.limit,
        search: params.search,
        statusList: params.statusList,
        from: params.from,
        to: params.to,
        offset: params.offset,
        scope: params.scope,
        isUrlUpdateDisabled: params.isUrlUpdateDisabled
    },
});

export const GetAllCheckoutsSuccess: ActionCreator<GetAllCheckoutsSuccessAction> = (
    list: SimpleLandingCheckout[],
    count: number,
    publishedCount?: number,
    unpublishedCount?: number,
): GetAllCheckoutsSuccessAction => ({
    type: CheckoutsActionTypes.GET_ALL_CHECKOUTS_SUCCESS,
    payload: {
        loadingTemplates: false,
        templatesList: list,
        count,
        publishedCount,
        unpublishedCount
    },
});

export const GetAllCheckoutsError: ActionCreator<GetAllCheckoutsErrorAction>  = (): GetAllCheckoutsErrorAction => ({
    type: CheckoutsActionTypes.GET_ALL_CHECKOUTS_ERROR,
    payload: {
        loadingTemplates: false,
    },
});

export const DeleteCheckout = (checkoutName: string[], UrlParams: GetCheckoutsParams): DeleteCheckoutAction => ({
    type: CheckoutsActionTypes.DELETE_CHECKOUTS,
    payload: {
        Names: checkoutName,
        UrlParams
    },
});
export const DeleteCheckoutSuccess = (): DeleteCheckoutSuccessAction => ({
    type: CheckoutsActionTypes.DELETE_CHECKOUTS_SUCCESS
});
export const DeleteCheckoutError = (): DeleteCheckoutErrorAction => ({
    type: CheckoutsActionTypes.DELETE_CHECKOUTS_ERROR
});

export const PickCheckouts = (checkedCheckouts: string[]): PickCheckoutsAction => ({
    type: CheckoutsActionTypes.PICK_CHECKOUTS,
    payload: {
        checkedCheckouts,
    },
});

export const UnpickAllCheckouts = (): UnpickAllCheckoutsAction => ({
    type: CheckoutsActionTypes.UNPICK_CHECKOUTS,
});

export const GetCheckoutByNameStart = (
    name: string,
    isTemplateThumbnailsRequired = false
): GetCheckoutByNameStartAction => ({
    type: CheckoutsActionTypes.GET_CHECKOUT_BY_NAME_START,
    payload: { name, isTemplateThumbnailsRequired },
});

export const GetCheckoutByNameSuccess = (
    singleCheckout: LandingPage,
): GetCheckoutByNameSuccessAction => ({
    type: CheckoutsActionTypes.GET_CHECKOUT_BY_NAME_SUCCESS,
    payload: {
        singleCheckout
    },
});

export const GetCheckoutByNameError = (): GetCheckoutByNameErrorAction => ({
    type: CheckoutsActionTypes.GET_CHECKOUT_BY_NAME_ERROR,
});


export const LoadPreviewTemplate = (name: string): LoadPreviewTemplateAction => ({
    type: CheckoutsActionTypes.LOAD_PREVIEW_TEMPLATE,
    payload: {
        name,
        previewLoading: true
    },
});

export const LoadPreviewTemplateSuccess = (checkout: LandingCheckout): LoadPreviewTemplateSuccessAction => ({
    type: CheckoutsActionTypes.LOAD_PREVIEW_TEMPLATE_SUCCESS,
    payload: {
        checkout,
        previewLoading: false
    }

});

export const LoadPreviewTemplateError = (): LoadPreviewTemplateErrorAction => ({
    type: CheckoutsActionTypes.LOAD_PREVIEW_TEMPLATE_ERROR,
    payload: {
        previewLoading: false
    }
});

export const UpdateCheckoutStatus = (name: string, status: LandingCheckoutStatusEnum): UpdateCheckoutStatusStartAction => ({
    type:  CheckoutsActionTypes.UPDATE_CHECKOUT_STATUS,
    payload: {
        name,
        status
    }
});

export const UpdateCheckoutStatusSuccess = (status: LandingCheckoutStatusEnum, name: string): UpdateCheckoutStatusSuccessAction => ({
    type:  CheckoutsActionTypes.UPDATE_CHECKOUT_STATUS_SUCCESS,
    payload: {
        status,
        name
    }
});
export const UpdateCheckoutStatusError = (name: string): UpdateCheckoutStatusErrorAction => ({
    type:  CheckoutsActionTypes.UPDATE_CHECKOUT_STATUS_ERROR,
    payload: {
        name
    }
});

export const ClearPreviewTemplate = (): ClearPreviewTemplateAction => ({
    type: CheckoutsActionTypes.CLEAR_PREVIEW_TEMPLATE,
    payload: null,
});

export const getCheckoutsStore = (state: ApplicationState): CheckoutListState => state.checkoutsList;
